import { createApiClient } from "@trillion/ui/lib/api-client";
import { getEnv } from "@trillion/ui/lib/env";
import { mcpConsentDecisionRequestSchema } from "@trillion/validation";

export interface McpConsentView {
  request_id: string;
  account: { email: string; display_name: string | null };
  client: { client_id: string; display_name: string | null };
  connection_id: string;
  resource: string;
  scopes: string[];
  offline_access: boolean;
  expires_at: string;
  csrf_token: string;
}

export interface McpConsentDecision {
  continue_url: string;
  connection_id: string;
  approved: boolean;
}

const api = createApiClient(() => getEnv("PASSPORT_API_URL"));
export const mcpConsentApi = {
  get(requestId: string, signal?: AbortSignal) {
    return api.request<McpConsentView>(`/api/mcp/consent?requestId=${encodeURIComponent(requestId)}`, { signal });
  },
  decide(requestId: string, approve: boolean, csrfToken: string) {
    const body = mcpConsentDecisionRequestSchema.parse({ request_id: requestId, approve });
    return api.request<McpConsentDecision>("/api/mcp/consent", {
      method: "POST", headers: { "X-CSRF-TOKEN": csrfToken }, body: JSON.stringify(body),
    });
  },
};
